/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import CrcConfigApi, { CrcConfigDOI } from '../api/crcConfigApi'
import CrcConfig from '../crcConfig';
import EnumStationType from 'src/enums/enumStationType';
import alertCrcConfigModal from '../crcconfigModal';
import { Toast } from 'src/util/toast';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';

export default class CrcConfigService extends ListPageService {
    ctx: CrcConfig;
    
    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

    constructor (ctx: CrcConfig) {
        super()
        this.ctx = ctx
    }

    @override
    createColumns (): ColDefCustom [] {
        let t = this
        return [
            {
                headerName: 'crc',
                field: 'crc',
                minWidth: 160,
            },
            {
               headerName: '文件名称',
               field: 'file_name',
               minWidth: 160,
            },
            {
               headerName: '操作',
               field: 'operate',
               minWidth: 400,
               cellRendererFramework: CellOperate,
               cellRendererFrameworkOpt: [
                   {
                       text: '删除',
                       async click(params) {
                           let res = await Toast.confirm();
                           if (!res) {
                               return;
                           }
                           let data: CrcConfigDOI.RowDataI = params.data;
                           await t.delete(data.id);
                       },
                   }
               ],
           },
        ]
   }

    @override
   createBtnGroup(): Array<IconBtnItem> {
       let t = this;
       return [
           {
               text: '新增',
               async onClick() {
                   let res = await alertCrcConfigModal(EnumOperates.Add.getName());
                   if (res) {
                       t.searchTable();
                   }
               },
           },
       ];
   }

   async delete(id: Integer) {
       let { code } = await CrcConfigApi.delete(id);
       if (code === 0) {
           Toast.success('删除成功');
           this.searchTable();
       }
   }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [];
    }


    @override
    initSearchParams (): void {
        this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<CrcConfigDOI.QueryRowDataParamsI>(),
            page_index: this.ctx.currentPage,
            page_size: this.ctx.pageSize,
        }
        this.ctx.currentPage = 1
    }

    @override
    async searchTable () {
        let ctx = this.ctx
        let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
        ag.showLoading()
        let {code, data} = await CrcConfigApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage
        })
        ag.hideLoading()

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count
        }
    }

}
